import "./ConnectionIndicator.css";

type ConnectionIndicatorProps = {
  connected: boolean;
};

export const ConnectionIndicator = ({ connected }: ConnectionIndicatorProps) => {
  if (connected) {
    return null;
  }

  return (
    <div className="ConnectionIndicator">
      <span className="ConnectionIndicator__dot" />
      <span className="ConnectionIndicator__text">
        Ingen forbindelse — opdaterer hvert 30. sekund
      </span>
    </div>
  );
};
